"use client";

import { c as _c } from "react/compiler-runtime";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { PlusIcon } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem } from "@/lib/components/accordion";
import { serializeJsonLd } from "@/lib/json-ld";
export interface CompareFaqItem {
  question: string;
  answer: string;
}
interface CompareFaqProps {
  heading: string;
  description?: string;
  faqs: CompareFaqItem[];
}
export function CompareFaq(t0) {
  const $ = _c(31);
  const {
    heading,
    description,
    faqs
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== faqs) {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map(_temp)
    };
    t3 = "w-full py-20 md:py-28 bg-background";
    t4 = "faq";
    t2 = "application/ld+json";
    t1 = serializeJsonLd(faqSchema);
    $[0] = faqs;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = {
      __html: t1
    };
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <script type={t2} dangerouslySetInnerHTML={t5} />;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-4">FAQ</p>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== heading) {
    t8 = <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">{heading}</h2>;
    $[11] = heading;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== description) {
    t9 = description ? <p className="mt-4 text-muted-foreground">{description}</p> : null;
    $[13] = description;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="mt-6 text-sm text-muted-foreground">Can't find an answer?{" "}<a href="mailto:contact@llmgateway.io" className="text-foreground underline underline-offset-4">Contact us</a></p>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t8 || $[17] !== t9) {
    t11 = <div className="lg:col-span-2 lg:sticky lg:top-24 lg:self-start">{t7}{t8}{t9}{t10}</div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== faqs) {
    t12 = faqs.map(_temp2);
    $[19] = faqs;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <div className="lg:col-span-3"><Accordion type="single" collapsible={true} className="w-full" defaultValue="item-1">{t12}</Accordion></div>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <div className="container mx-auto px-4 md:px-6"><div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">{t11}{t13}</div></div>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14 || $[27] !== t3 || $[28] !== t4 || $[29] !== t6) {
    t15 = <section className={t3} id={t4}>{t6}{t14}</section>;
    $[26] = t14;
    $[27] = t3;
    $[28] = t4;
    $[29] = t6;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
}
function _temp2(item_0, index) {
  return <AccordionItem key={item_0.question} value={`item-${index + 1}`} className="py-5 border-border/50"><AccordionPrimitive.Header className="flex"><AccordionPrimitive.Trigger className="focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-md py-2 text-left font-display text-lg md:text-xl font-medium leading-7 transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&>svg>path:last-child]:origin-center [&>svg>path:last-child]:transition-all [&>svg>path:last-child]:duration-200 [&[data-state=open]>svg]:rotate-180 [&[data-state=open]>svg>path:last-child]:rotate-90 [&[data-state=open]>svg>path:last-child]:opacity-0 text-foreground">{item_0.question}<PlusIcon size={18} className="pointer-events-none shrink-0 opacity-60 transition-transform duration-200" aria-hidden="true" /></AccordionPrimitive.Trigger></AccordionPrimitive.Header><AccordionContent className="overflow-hidden transition-all data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up text-base text-muted-foreground leading-relaxed pb-2"><div className="border-l-2 border-foreground/10 pl-4">{item_0.answer}</div></AccordionContent></AccordionItem>;
}
function _temp(item) {
  return {
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer
    }
  };
}